module.exports = __webpack_public_path__ + "img/charger-circle.a337b597.png";